<template>
  <el-container class="background-white">
    <el-header>
      <h1>D365 Webhooks</h1>
    </el-header>
    <div class="card__body">
      <el-row :gutter="24">
        <el-col :span="10">
          <el-input placeholder="Search Style-Color here" v-model="searchQuery" />
        </el-col>
        <el-col :span="5">
          <el-select v-model="region" placeholder="Select">
            <el-option
              v-for="item in sites"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="success" @click="search" :disabled="loading">
            Search
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-main>
      <el-table v-loading="loading" :data="data.data">
        <el-table-column label="Received" width="300">
          <template #default="props">
            {{ props.row.created_at | utcToPct }} PCT
          </template>
        </el-table-column>
        <el-table-column prop="region" label="Region" />
        <el-table-column prop="payload.style" label="Style" />
        <el-table-column prop="payload.color" label="Colour" />
        <el-table-column prop="payload.size" label="Size" />
        <el-table-column prop="payload.quantity" label="Quantity" />
        <el-table-column prop="payload.payload" label="Payload" width="300" />
      </el-table>
      <br>
      <el-pagination
        background
        layout="prev, pager, next, ->, total"
        :page-size="Number(data.per_page)"
        :total="data.total"
        :page-count="data.last_page"
        :current-page="data.current_page"
        @current-change="currentChangeHandler"
        @size-change="sizeChangeHandler"
      />
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment';
import notify from '../../mixins/notify';
import axios, { RepositoryError } from '../../repositories';

export default {
  name: 'D365WebhookMonitoringTable',
  created() {
    this.fetch();
  },
  data() {
    return {
      region: '',
      searchQuery: '',
      loading: true,
      data: {},
      url: 'monitoring/webhooks',
      sizes: [10, 20, 30, 40, 50],
      limit: 10,
      page: 1,
      sites: [
        { value: 'usa', label: 'USA' },
        { value: 'ca', label: 'Canada' },
      ],
    };
  },
  methods: {
    async search() {
      if (
        this.searchQuery.trim() === '' ||
        !this.searchQuery.trim().match(/^.+[-].+$/)
      ) {
        return this.notify(
          'Please enter a Style-Color in the search field',
          'danger',
        );
      }

      if (this.region.trim() === '') {
        return this.notify(
          'Please select a region from the drop down list',
          'danger',
        );
      }

      try {
        this.loading = true;

        const response = await axios.get('/monitoring/webhooksWithParams', {
          params: {
            region: this.region,
            sku: this.searchQuery,
          },
        });
        this.data = response.data;
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      } finally {
        this.loading = false;
      }
    },
    async fetch() {
      try {
        this.loading = true;

        const response = await axios.get(this.url, {
          params: {
            page: this.page,
            limit: this.limit,
          },
        });
        this.data = response.data;
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      } finally {
        this.loading = false;
      }
    },
    currentChangeHandler(page) {
      this.page = page;
      this.fetch();
    },
    sizeChangeHandler(limit) {
      this.limit = limit;
      this.fetch();
    },
  },
  filters: {
    utcToLocal(value) {
      return moment.utc(value).local().format('dddd, MMMM Do YYYY, h:mm:ss a');
    },
    utcToPct(value) {
      const dateUtc = new Date(value);
      const options = {
        timeZone: 'America/Vancouver',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
        second: 'numeric',
        hourCycle: 'h23',
      };
      return dateUtc.toLocaleString('en-CA', options);
    },
  },
  mixins: [notify],
};
</script>
